import React from "react";
import "./inputComponent.css";
import Form from "react-bootstrap/Form";

const InputComponent = ({
  id,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
}) => {
  return (
    <Form.Group controlId={id} className="input-component ">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Form.Group>
  );
};

export default InputComponent;
